module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-3_BW2-p-1600-8ec9376f8df29f870c06d36482693bad.jpg";